import { lazy } from 'solid-js'
import { messages } from '../../pages/lodgr-insights-page/lodgr-insights-page-routing.messages.en.js'

/*
    TENANT-5421. Conference page for STR Summit 2026 (Huatulco) — hosts reach
    it by QR code at the booth.

    Unlisted like /browser-demo: `noIndex: true` emits `noindex,follow` and the
    path is deliberately absent from `sitemap-routes.js`. James is deciding at
    PR time whether it stays unlisted or joins the sitemap — if it should be
    indexed, remove `noIndex` AND add the path there.
*/
export default {
    component: lazy(() => import('../../pages/lodgr-insights-page/lodgr-insights-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    noIndex: true,
    path: '/lodgr-insights',
    // The Figma frame (12848-15406) hides the site footer; the sticky gateway
    // CTA occupies that space instead.
    showFooter: false,
    titleMessage: messages.titleMessage,
}
